import ManagePosition from '../../../views/Personnel/Letter/ManagePosition.letter.view';

export default ManagePosition;
